export default function VisionMission() {
    return (
        <>
            <section id="vision-mission-section">
                <div className="vision-mission-container">
                    <div className="vision-mission-header">
                        <h2 className="section-title">Our Vision & Mission</h2>
                        <p className="section-subtitle">Guiding principles that drive our commitment to musical excellence</p>
                    </div>

                    <div className="vision-mission-content">
                        <div className="vision-section">
                            <div className="vision-header">
                                <div className="vision-icon">
                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <h3 className="vision-title">Our Vision</h3>
                            </div>
                            <div className="vision-text">
                                <p>To create one of India’s most premier music academies that nurtures raw talent into professional artistry, seamlessly blending traditional and modern approaches, while shaping versatile, world-class musicians who inspire and lead globally.</p>
                            </div>
                        </div>

                        <div className="mission-section">
                            <div className="mission-header">
                                <div className="mission-icon">
                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                        <polyline points="7.5,4.21 12,6.81 16.5,4.21" />
                                        <polyline points="7.5,19.79 7.5,14.6 3,12" />
                                        <polyline points="21,12 16.5,14.6 16.5,19.79" />
                                        <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
                                        <line x1="12" y1="22.08" x2="12" y2="12" />
                                    </svg>
                                </div>
                                <h3 className="mission-title">Our Mission</h3>
                            </div>
                            <div className="mission-points">
                                <div className="mission-point">
                                    <div className="point-number">01</div>
                                    <div className="point-content">
                                        <span>To provide structured, high-quality training in multiple musical disciplines.</span>
                                    </div>
                                </div>

                                <div className="mission-point">
                                    <div className="point-number">02</div>
                                    <div className="point-content">
                                        <span>To foster both passion-driven learning and career-focused skill development.</span>
                                    </div>
                                </div>

                                <div className="mission-point">
                                    <div className="point-number">03</div>
                                    <div className="point-content">
                                        <span>To create an inclusive, inspiring, and professional learning environment where students thrive.</span>
                                    </div>
                                </div>

                                <div className="mission-point">
                                    <div className="point-number">04</div>
                                    <div className="point-content">
                                        <span>To bridge the gap between Indian and Western music education by offering graded certifications (Trinity, Rockschool, ABRSM, Bhatkhande, Banasthali, etc.).</span>
                                    </div>
                                </div>

                                <div className="mission-point">
                                    <div className="point-number">05</div>
                                    <div className="point-content">
                                        <span>To build a community of confident performers, creators, and lifelong learners of music.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 